import { AxiosResponse } from "axios";
import { BaseCandidate } from "./bases/base.service";

export default class CandidateService {}
